import TheLayout from '@/views/layouts/TheLayout.vue'
import { RouteRecordRaw } from 'vue-router'

const routes = [
  {
    path: '/',
    component: TheLayout,
    children: [
      {
        path: '',
        name: 'Landing',
        component: () => import('@/views/pages/Landing/Index.vue'),
      },
      {
        path: 'ecovadis',
        name: 'Ecovadis',
        component: () => import('@/views/pages/Ecovadis/Index.vue'),
      },
      // Lead magnets
      {
        path: 'ghg-calculator',
        name: 'GhgCalculator',
        component: () => import('@/views/pages/GhgCalculator/Index.vue'),
      },
      {
        path: 'webinar',
        name: 'Webinar',
        component: () => import('@/views/pages/Webinar/Index.vue'),
      },
      {
        path: 'csrd-check',
        name: 'CSRDCheck',
        component: () => import('@/views/pages/CSRDCheck/Index.vue'),
      },
      {
        path: 'esrs-vsme-gri-reporting',
        name: 'ESRSVSMEGRIReporting',
        component: () => import('@/views/pages/CSRDConfidence/Index.vue'),
      },
      {
        path: 'carbon-accounting',
        name: 'CarbonAccounting',
        component: () => import('@/views/pages/CarbonAccounting/Index.vue'),
      },
      {
        path: 'net-zero',
        name: 'NetZero',
        component: () => import('@/views/pages/NetZero/Index.vue'),
      },
      {
        path: 'sbti',
        name: 'SBTi',
        component: () => import('@/views/pages/SBTi/Index.vue'),
      },
      {
        path: 'manufacturing',
        name: 'Manufacturing',
        component: () => import('@/views/pages/Manufacturing/Index.vue'),
      },
      {
        path: 'contact',
        name: 'Contact',
        component: () => import('@/views/pages/Contact/Index.vue'),
      },
      {
        path: 'demo',
        name: 'Demo',
        component: () => import('@/views/pages/Demo/Index.vue'),
      },
      {
        path: 'bcorp',
        name: 'BCorp',
        component: () => import('@/views/pages/BCorp/Index.vue'),
      },
      // 410 Gone pages - permanently removed content
      {
        path: 'category/uncategorized',
        name: 'CategoryUncategorized410',
        component: () => import('@/views/pages/Error410/Index.vue'),
      },
      {
        path: 'newsletter',
        name: 'Newsletter410',
        component: () => import('@/views/pages/Error410/Index.vue'),
      },
      {
        path: '404',
        name: 'Error404',
        component: () => import('@/views/pages/Error404/Index.vue'),
      },
      {
        path: '/:slug(.*)',
        name: 'StaticPage',
        component: () => import('@/views/pages/Static/StaticHtml.vue'),
      },
    ],
  },
  // Catch-all 404 route - must be last
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    redirect: '/404',
  },
] as RouteRecordRaw[]

export default routes
